import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { ServiceRecord } from '../api/types';
import config from '../config';

async function getServiceRecord(axios: AxiosInstance, id: number): Promise<ServiceRecord> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v2/service-record/` + id);
  return data.data;
}

export default function useServiceRecordQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getServiceRecord(axios, id),
    notifyOnChangeProps: ['data', 'isFetching', 'isLoading', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number) {
  return ['ServiceRecord', id] as const satisfies QueryKey;
}
useServiceRecordQuery.getKey = getKey;
